import { render, staticRenderFns } from "./SystemInfoTable.vue?vue&type=template&id=2a56e661&scoped=true"
import script from "./SystemInfoTable.vue?vue&type=script&lang=js"
export * from "./SystemInfoTable.vue?vue&type=script&lang=js"
import style0 from "./SystemInfoTable.vue?vue&type=style&index=0&id=2a56e661&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a56e661",
  null
  
)

export default component.exports